import { AsyncState, ProviderOption, UserSelfApplyState } from './types';
import { QueryStatuses } from '../constants';
import {
  USER_SELF_APPLY_ALLOCATE_REQUEST,
  USER_SELF_APPLY_ALLOCATE_SUCCESS,
  USER_SELF_APPLY_ALLOCATE_FAILURE,
  USER_SELF_APPLY_PROVIDERS_REQUEST,
  USER_SELF_APPLY_PROVIDERS_SUCCESS,
  USER_SELF_APPLY_PROVIDERS_FAILURE,
} from './actions';

const {
  PRISTINE,
  PENDING,
  FAILURE,
  SUCCESS,
} = QueryStatuses;

const initialAsync = { data: null as any, status: PRISTINE, error: null } as AsyncState<any>;

const initialState: UserSelfApplyState = {
  providers: { ...initialAsync, data: [] as ProviderOption[] },
  allocateRequest: { loading: false },
};

export function userSelfApplyReducer(state = initialState, action: any): UserSelfApplyState {
  switch (action.type) {
    case USER_SELF_APPLY_ALLOCATE_REQUEST:
      return { ...state, allocateRequest: { loading: true } };
    case USER_SELF_APPLY_ALLOCATE_SUCCESS:
      return { ...state, allocateRequest: { loading: false } };
    case USER_SELF_APPLY_ALLOCATE_FAILURE:
      return { ...state, allocateRequest: { loading: false } };

    case USER_SELF_APPLY_PROVIDERS_REQUEST:
      return { ...state, providers: { ...state.providers, status: PENDING, error: null } };
    case USER_SELF_APPLY_PROVIDERS_SUCCESS:
      return { ...state, providers: { data: action.payload, status: SUCCESS, error: null } };
    case USER_SELF_APPLY_PROVIDERS_FAILURE:
      return { ...state, providers: { ...state.providers, status: FAILURE, error: action.payload } };

    default:
      return state;
  }
}


